import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import authSelectors from '../../store/selectors/auth'

import {
  IForm_File,
} from '@kaidam/fc-shared/src/types/schema/form'

import {
  StorageFile,
} from '@kaidam/fc-shared/src/utils/storage'

const useFileUrl = (file?: IForm_File): string => {
  const token = useSelector(authSelectors.token)
  const url = useMemo(() => {
    if(!file) return ''
    const storageFile = StorageFile(file, token)
    return storageFile.url()
  }, [
    token,
    file,
  ])

  return url
}

export default useFileUrl